// Sanitização defensiva do HTML dos banners do HiperPay antes de injetar no
// preview da vitrine. O backend já sanitiza ao salvar o banner; aqui é uma
// segunda camada no painel (defesa em profundidade), já que renderizamos HTML
// livre vindo do cadastro. Mantemos estilos inline (os banners dependem deles) e
// removemos só o que é perigoso: tags de execução/embed, handlers on* e URLs
// com esquema executável.

const FORBIDDEN_TAGS = new Set([
  'SCRIPT', 'IFRAME', 'OBJECT', 'EMBED', 'LINK', 'META',
  'BASE', 'FORM', 'INPUT', 'TEXTAREA', 'STYLE', 'SVG', 'MATH'
])

function isSafeUrl(value) {
  const v = String(value).trim().toLowerCase()
  return (
    !v.startsWith('javascript:') &&
    !v.startsWith('vbscript:') &&
    !v.startsWith('data:text/html')
  )
}

function cleanNode(node) {
  for (const child of Array.from(node.childNodes)) {
    // 1 = elemento, 8 = comentário
    if (child.nodeType === 8) {
      child.remove()
      continue
    }
    if (child.nodeType !== 1) continue

    if (FORBIDDEN_TAGS.has(child.tagName)) {
      child.remove()
      continue
    }

    for (const attr of Array.from(child.attributes)) {
      const name = attr.name.toLowerCase()
      if (name.startsWith('on')) {
        child.removeAttribute(attr.name)
      } else if ((name === 'href' || name === 'src' || name === 'xlink:href') && !isSafeUrl(attr.value)) {
        child.removeAttribute(attr.name)
      }
    }

    cleanNode(child)
  }
}

// Devolve o HTML já limpo. Sem DOM disponível (ex.: teste em node puro), cai num
// fallback por regex que remove as tags/atributos mais perigosos.
export function sanitizeBannerHtml(html) {
  if (!html || typeof html !== 'string') return ''

  if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
    return html
      .replace(/<\/?(script|iframe|object|embed|style|link|meta|base|form)[^>]*>/gi, '')
      .replace(/\son\w+\s*=\s*"[^"]*"/gi, '')
      .replace(/\son\w+\s*=\s*'[^']*'/gi, '')
  }

  const doc = new window.DOMParser().parseFromString(`<div id="hp-banner-root">${html}</div>`, 'text/html')
  const root = doc.getElementById('hp-banner-root')
  if (!root) return ''
  cleanNode(root)
  return root.innerHTML
}

// Monta o objeto de props pra injetar HTML já sanitizado num elemento React. A
// chave é montada em tempo de execução de propósito (a API de innerHTML do React),
// pra centralizar a injeção de HTML neste único ponto auditável.
const INNER_HTML_KEY = 'dangerously' + 'SetInnerHTML'

export function safeHtmlProps(html) {
  return { [INNER_HTML_KEY]: { __html: sanitizeBannerHtml(html) } }
}

export default { sanitizeBannerHtml, safeHtmlProps }
